module.exports = __webpack_public_path__ + "img/icon_blue-small_dollar-sign.03c8d03c.svg";